import type { BrandId, LayoutType } from "@ifa/utils";

import type { AppId, TenantId, ThemeContext } from "../core/types.ts";

export interface ResolveThemeContextOptions {
  tenantId: TenantId;
  brandId?: BrandId;
  appId: AppId;
  layoutType: LayoutType;
}

export function resolveThemeContext(
  options: ResolveThemeContextOptions
): ThemeContext {
  return {
    tenantId: options.tenantId,
    brandId: options.brandId ?? options.tenantId,
    appId: options.appId,
    layoutType: options.layoutType,
  };
}
